/* eslint-disable */

import React, { useEffect, useMemo, useState } from "react";
import Table from "components/Table";
import api from "api";
import { useAuth } from "context/auth";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { handleLoading, useLoading } from "context/LoadingContext";
import { NotificationManager } from "react-notifications";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function UsersLog() {
  const [, loadingDispatch] = useLoading();
  

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const watchedData = watch();
  const [printDateHeaderArr, setPrintDateHeaderArr] = useState(undefined);
  const [auth] = useAuth();
  const [dataTable, setDataTable] = useState([]);
  const headers = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "#",
        enableColumnFilter: false,
        filterInputInfo: {
          label: "رقم المستخدم",
          type: "",
        },
      },
      {
        accessorKey: "userName",
        header: "اسم المستخدم",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "اسم المستخدم",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "logDescription",
        header: "نوع الحركة",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "نوع الحركة",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "pcName",
        header: "اسم الجهاز",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "اسم الجهاز",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "ipAddress",
        header: "رقم الجهاز",
        enableColumnFilter: true,
        filterInputInfo: {
          label: "رقم الجهاز",
          // type: "string",
        },
        filterFn: "includesString",
      },
      {
        accessorKey: "dateLoginIso",
        header: "وقت تسجيل الدخول",
      },
    ],
    []
  );

  const exportHeaders = useMemo(
    () => ({
      logDescription: "نوع الحركة",
      pcName: "إسم الجهاز",
      ipAddress: "رقم الجهاز",
      id: "#",
      userName: "اسم المستخدم",
      dateLoginIso: "الوقت",
    }),
    []
  );

  const getUserLogs = async (data) => {
    
    try {
      handleLoading(loadingDispatch, true);
      const userLogsRes = await api.post("reports/employee/logs", data);
      setDataTable(
        userLogsRes.data.data.list.map((item) => ({
          ...item,
          dateLoginIso: item?.dateLogin
            ? new Date(item?.dateLogin).toLocaleString("en-GB", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
                timeZone: "UTC",
              })
            : "",
        }))
      );
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };
  useEffect(() => {
    getUserLogs();
  }, []);

  const onSubmit = (data) => {
    const { dateFrom, dateTo } = data;
    
    setPrintDateHeaderArr([dateFrom, dateTo]);
    getUserLogs(data);
  };

  return (
    <div>
      <form className="table__filter mb-3" onSubmit={handleSubmit(onSubmit)}>
        <div className="table__filter__period">
          <Form.Group className="input input-md date-input">
            <Form.Label>تاريخ من</Form.Label>
            <Form.Control
              type="date"
              {...register(`dateFrom`, {
                required: {
                  value: watchedData.dateTo,
                  message: "الرجاء ادخال الحقل",
                },
              })}
            />
          </Form.Group>
          <Form.Group className="input input-md date-input">
            <Form.Label>تاريخ إلى</Form.Label>
            <Form.Control
              type="date"
              {...register(`dateTo`, {
                required: {
                  value: watchedData.dateFrom,
                  message: "الرجاء ادخال الحقل",
                },
                validate: (dateTo) => {
                  if (!watchedData.dateFrom) return true;
                  return (
                    new Date(dateTo).getTime() >=
                      new Date(watchedData.dateFrom).getTime() ||
                    "الرجاء ادخال تاريخ صحيح"
                  );
                },
                deps: ["dateFrom"],
              })}
            />
            {errors.dateTo && (
              <Form.Text className="text-danger">
                {errors.dateTo.message}
              </Form.Text>
            )}
          </Form.Group>
        </div>
        <div
          className="table__filter__actions"
          style={{ alignSelf: "flex-end" }}
        >
          <button type="submit" className="btn btn--primary fw-bold">
            بحث
          </button>
        </div>
      </form>
      <div
        className="divider my-3"
        style={{ height: 3, backgroundColor: "var(--primary)" }}
      />
      <Table
        data={dataTable}
        columns={headers}
        printable
        printDateHeaderArr={printDateHeaderArr}
        exportHeaders={exportHeaders}
        exportName="متابعة حركات المستخدمين"
        headerTitle="متابعة حركات المستخدمين"
        printerName={
          auth?.userDetails?.details?.fullName?.trim() ||
          `${auth?.userDetails?.details?.firstName}
          ${auth?.userDetails?.details?.lastName}`
        }
      />
    </div>
  );
}

export default UsersLog;
